<template>
  <div class="p-menus-no-detail-infomation">
    <div v-for="item in infoData" :key="item.id">
      <p v-if="item.title" class="p-menus-no-detail-infomation__header">
        {{ item.title }}
      </p>
      <div
        v-if="item.content || item.linkUrl"
        class="p-menus-no-detail-infomation__body"
      >
        <p v-if="item.content">{{ item.content }}</p>
        <a
          v-if="item.linkUrl"
          :href="item.linkUrl"
          class="p-menus-no-detail-infomation__link"
          target="_blank"
        >
          {{ item.linkNm }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuInfomation: {
      type: Array,
      default: () => ([])
    },
    planInfomation: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
    };
  },
  computed: {
    infoData() {
      if (this.menuInfomation && this.menuInfomation.length > 0) {
        return this.menuInfomation;
      } else if (this.planInfomation && this.planInfomation.length > 0) {
        return this.planInfomation;
      }
      return []
    }
  },
};
</script>

<style lang="scss" scoped>
@import './p-menus-no-detail-infomation.scss';
</style>
